import { createContext, useContext } from 'react';

export interface BrowserSessionContextValue {
  unifiedSessionId: string | null;
}

export const BrowserSessionContext = createContext<BrowserSessionContextValue>({
  unifiedSessionId: null,
});

export function useBrowserSession() {
  return useContext(BrowserSessionContext);
}
